import Link from "next/link";

type Stack = {
  name: string;
  glyph: string;
  bg: string;
  fg: string;
};

const STACKS: Stack[] = [
  { name: "Next.js", glyph: "N", bg: "#000", fg: "#fff" },
  { name: "React", glyph: "⚛", bg: "#20232a", fg: "#61dafb" },
  { name: "Python", glyph: "py", bg: "#306998", fg: "#ffd43b" },
  { name: "Go", glyph: "Go", bg: "#00add8", fg: "#fff" },
  { name: "Node", glyph: "JS", bg: "#3c873a", fg: "#fff" },
  { name: "Rust", glyph: "🦀", bg: "#2b2b2b", fg: "#deb887" },
  { name: "Ruby", glyph: "💎", bg: "#cc342d", fg: "#fff" },
  { name: "PHP", glyph: "php", bg: "#777bb4", fg: "#fff" },
  { name: "Docker", glyph: "🐳", bg: "#0db7ed", fg: "#fff" },
  { name: "Postgres", glyph: "🐘", bg: "#336791", fg: "#fff" },
  { name: "FastAPI", glyph: "⚡", bg: "#009688", fg: "#fff" },
  { name: "Astro", glyph: "▲", bg: "#0d0e10", fg: "#ff5d01" }
];

export const WhatCanIDeploy = () => (
  <section id="stacks" className="max-w-[1140px] mx-auto px-8 py-24">
    <div className="max-w-[720px] mx-auto text-center mb-14">
      <div className="inline-block text-xs text-primary bg-primary/8 px-3 py-1 rounded-full mb-4 font-medium tracking-wide lowercase font-mono">
        works with whatever you wrote
      </div>
      <h2 className="font-serif text-[clamp(36px,5.5vw,56px)] leading-[1.05] tracking-tight font-normal mb-4 text-foreground text-balance">
        If it runs on your laptop,
        <br />
        <em className="text-primary">it&apos;ll run on ours.</em>
      </h2>
      <p className="text-[17px] leading-relaxed text-muted-foreground text-pretty">
        Next.js, Python, Go, Rust, Ruby, PHP, your weird side project — we got it. If it has a
        Docker Compose file, even better.
      </p>
    </div>
    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
      {STACKS.map(s => (
        <div
          key={s.name}
          className="bg-card border rounded-xl py-5 px-3 flex flex-col items-center gap-3 hover:-translate-y-0.5 hover:border-foreground/20 transition-all"
        >
          <div
            className="w-[50px] h-[50px] rounded-xl flex items-center justify-center text-[19px] font-bold font-mono"
            style={{ background: s.bg, color: s.fg }}
            aria-hidden="true"
          >
            {s.glyph}
          </div>
          <div className="text-[13px] font-medium text-secondary-foreground">{s.name}</div>
        </div>
      ))}
    </div>
    <div className="text-center mt-8 text-sm text-muted-foreground">
      &hellip;and much more.{" "}
      <Link
        href="/faq"
        className="text-primary border-b border-dashed border-primary/40 hover:text-primary/80 transition-colors"
      >
        See the FAQ →
      </Link>
    </div>
  </section>
);
